import React from 'react';

export const User = React.createContext();

export const UserDispatch = React.createContext(() => {});
